/* cart icon */
let cart_num = document.querySelector('[rel="js-eccart-num-hidden"]');
let cart_num_observer = new MutationObserver(function(mutationsList) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {
      num = $('.cart-count-bubble span[aria-hidden="true"]').html();
      $('[rel="js-eccart-num"]').html(num);
    }
  }
});
cart_num_observer.observe(cart_num, {
  childList: true,
  subtree: true
});

/* login recover */
$('a[href="#recover"]').click(function(){
  window.location.href = '/account/login#recover';
});
$('a[href="#login"]').click(function(){
  window.location.href = '/account/login#login';
});

/* api test */
// $(function(){
//   $.ajax({
//       url: JS_APP_URL+'api/ectop/topics/',
//       jsonpCallback: 'ectoptopics',
//       dataType: 'jsonp',
//       success: function (data) {
//         console.log('api test');
//         console.log(data);
//       }
//   });
// })